import React from "react"
import { Row, Input, Select, Col } from "antd"
import { observer } from "mobx-react"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import { ROB_OPTIONS, CHROMOSOME_OPTIONS } from "app/utils/const"

const Option = Select.Option

const Null = () => null

const Other = observer(({ traninfo, onTraninfoChange }) => {
  return (
    <Row type="flex" justify="center">
      <Col span={5}>
        <MaterialFormItem
          labelWidth={25}
          justify="center"
          required={true}
          labelText="name"
        >
          <Input
            value={traninfo.name}
            placeholder='name'
            onChange={(e) => {
              onTraninfoChange(traninfo, 'name', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="染色体"
          justify="center"
        >
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='染色体'
            value={traninfo.chromosome || undefined}
            onChange={(chromosome) => {
              onTraninfoChange(traninfo, 'chromosome', chromosome, this)
            }}
          >

            <Option value='chr1'>chr1</Option>
            <Option value='chr2'>chr2</Option>
            <Option value='chr3'>chr3</Option>
            <Option value='chr4'>chr4</Option>
            <Option value='chr5'>chr5</Option>
            <Option value='chr6'>chr6</Option>
            <Option value='chr7'>chr7</Option>
            <Option value='chr8'>chr8</Option>
            <Option value='chr9'>chr9</Option>
            <Option value='chr10'>chr10</Option>
            <Option value='chr11'>chr11</Option>
            <Option value='chr12'>chr12</Option>
            <Option value='chr13'>chr13</Option>
            <Option value='chr14'>chr14</Option>
            <Option value='chr15'>chr15</Option>
            <Option value='chr16'>chr16</Option>
            <Option value='chr17'>chr17</Option>
            <Option value='chr18'>chr18</Option>
            <Option value='chr19'>chr19</Option>
            <Option value='chr20'>chr20</Option>
            <Option value='chr21'>chr21</Option>
            <Option value='chr22'>chr22</Option>
            <Option value='chrX'>chrX</Option>
            <Option value='chrY'>chrY</Option>
            {CHROMOSOME_OPTIONS.map(chromosome => (
              <Option
                key={chromosome.value}
                value={chromosome.value}
              >
                {chromosome.label}
              </Option>
            ))}
          </Select>
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={50}
          required={true}
          labelText="起始位置"
          justify="center"
        >
          <Input
            style={{ width: '120px' }}
            placeholder='起始位置'
            value={traninfo.startPosition}
            onChange={(e) => {
              onTraninfoChange(traninfo, 'startPosition', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={50}
          required={true}
          labelText="结束位置"
          justify="center"
        >
          <Input
            placeholder='结束位置'
            style={{ width: '120px' }}
            value={traninfo.endPosition}
            onChange={(e) => {
              onTraninfoChange(traninfo, 'endPosition', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
    </Row>
  )
})

const Trans = observer(({ traninfo, onTraninfoChange }) => {
  return (
    <Row type="flex" justify="center">

      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="trans*"
          justify="center"
        >
          <Input
            style={{ width: '120px' }}
            value={traninfo.name}
            readOnly
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="染色体"
          justify="center"
        >
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='染色体'
            value={traninfo.chromosome || undefined}
            onChange={(chromosome) => {
              onTraninfoChange(traninfo, 'chromosome', chromosome, this)
            }}
          >
            <Option value='chr1'>chr1</Option>
            <Option value='chr2'>chr2</Option>
            <Option value='chr3'>chr3</Option>
            <Option value='chr4'>chr4</Option>
            <Option value='chr5'>chr5</Option>
            <Option value='chr6'>chr6</Option>
            <Option value='chr7'>chr7</Option>
            <Option value='chr8'>chr8</Option>
            <Option value='chr9'>chr9</Option>
            <Option value='chr10'>chr10</Option>
            <Option value='chr11'>chr11</Option>
            <Option value='chr12'>chr12</Option>
            <Option value='chr13'>chr13</Option>
            <Option value='chr14'>chr14</Option>
            <Option value='chr15'>chr15</Option>
            <Option value='chr16'>chr16</Option>
            <Option value='chr17'>chr17</Option>
            <Option value='chr18'>chr18</Option>
            <Option value='chr19'>chr19</Option>
            <Option value='chr20'>chr20</Option>
            <Option value='chr21'>chr21</Option>
            <Option value='chr22'>chr22</Option>
            <Option value='chrX'>chrX</Option>
            <Option value='chrY'>chrY</Option>
            {CHROMOSOME_OPTIONS.map(chromosome => (
              <Option
                key={chromosome.value}
                value={chromosome.value}
              >
                {chromosome.label}
              </Option>
            ))}
          </Select>
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={25}
          required={true}
          labelText="断点"
          justify="center"
        >
          <Input
            style={{ width: '120px' }}
            placeholder='断点'
            value={traninfo.breakpoint}
            onChange={(e) => {
              onTraninfoChange(traninfo, 'breakpoint', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
      </Col>
    </Row>
  )
})

const Inv = observer(({ traninfo, onTraninfoChange }) => {
  return (
    <Row type="flex" justify="center">
      <Col span={5}>
        <MaterialFormItem
          labelWidth={25}
          justify="center"
          required={true}
          labelText="inv*"
        >
          <Input
            style={{ width: '120px' }}
            value={traninfo.name}
            readOnly
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="染色体"
          justify="center"
        >
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='染色体'
            value={traninfo.chromosome || undefined}
            onChange={(chromosome) => {
              onTraninfoChange(traninfo, 'chromosome', chromosome, this)
            }}
          >
            <Option value='chr1'>chr1</Option>
            <Option value='chr2'>chr2</Option>
            <Option value='chr3'>chr3</Option>
            <Option value='chr4'>chr4</Option>
            <Option value='chr5'>chr5</Option>
            <Option value='chr6'>chr6</Option>
            <Option value='chr7'>chr7</Option>
            <Option value='chr8'>chr8</Option>
            <Option value='chr9'>chr9</Option>
            <Option value='chr10'>chr10</Option>
            <Option value='chr11'>chr11</Option>
            <Option value='chr12'>chr12</Option>
            <Option value='chr13'>chr13</Option>
            <Option value='chr14'>chr14</Option>
            <Option value='chr15'>chr15</Option>
            <Option value='chr16'>chr16</Option>
            <Option value='chr17'>chr17</Option>
            <Option value='chr18'>chr18</Option>
            <Option value='chr19'>chr19</Option>
            <Option value='chr20'>chr20</Option>
            <Option value='chr21'>chr21</Option>
            <Option value='chr22'>chr22</Option>
            <Option value='chrX'>chrX</Option>
            <Option value='chrY'>chrY</Option>
            {CHROMOSOME_OPTIONS.map(chromosome => (
              <Option
                key={chromosome.value}
                value={chromosome.value}
              >
                {chromosome.label}
              </Option>
            ))}
          </Select>
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={50}
          required={true}
          labelText="起始位置"
          justify="center"
        >
          <Input
            style={{ width: '120px' }}
            placeholder='起始位置'
            value={traninfo.startPosition}
            onChange={(e) => {
              onTraninfoChange(traninfo, 'startPosition', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={50}
          required={true}
          labelText="结束位置"
          justify="center"
        >
          <Input
            style={{ width: '120px' }}
            placeholder='结束位置'
            value={traninfo.endPosition}
            onChange={(e) => {
              onTraninfoChange(traninfo, 'endPosition', e.target.value)
            }}
          />
        </MaterialFormItem>
      </Col>
    </Row>
  )
})

const Rob = observer(({ traninfo, onTraninfoChange }) => { 
  return (
    <Row type="flex" justify="center">
      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="染色体1"
          justify="center"
        >
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='染色体1'
            value={traninfo.chromosome || undefined}
            onChange={(chromosome) => 
              onTraninfoChange(traninfo, 'chromosome', chromosome, this)
            }
          >
            {ROB_OPTIONS.map((rob, index) => (
              <Option
                key={rob.value}
                value={rob.value}
                disabled={traninfo.chromosome2 === rob.value}
              >
                {rob.label}
              </Option>
            ))}
          </Select>
        </MaterialFormItem>
      </Col>
      <Col span={5}>
        <MaterialFormItem
          labelWidth={40}
          required={true}
          labelText="染色体2"
          justify="center"
        >
          <Select
            allowClear
            style={{ width: '120px' }}
            placeholder='染色体2'
            value={traninfo.chromosome2 || undefined}
            onChange={(chromosome) => 
              onTraninfoChange(traninfo, 'chromosome2', chromosome, this)
            }
          >
            {ROB_OPTIONS.map((rob, index) => (
              <Option
                key={rob.value}
                value={rob.value}
                disabled={traninfo.chromosome === rob.value}
              >
                {rob.label}
              </Option>
            ))}
          </Select>
        </MaterialFormItem>
      </Col>
      <Col span={10}></Col>
    </Row>
  )
})

export default {
  'trans': <Trans />,
  'inv': <Inv />,
  'other': <Other />,
  'null': <Null />,
  'rob': <Rob />
}


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage_detail/containers/TraninfosMap.js